import { render, staticRenderFns } from "./AlunosEmAtencao.vue?vue&type=template&id=3fc9eb07"
import script from "./AlunosEmAtencao.vue?vue&type=script&lang=js"
export * from "./AlunosEmAtencao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports